import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import utf8 from "utf8";

class StudentRouteStore {
    loading = false;
    total = 0;
    routelist = [];
    studentAreaList = [];
    routeDetailedData = [];
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            loading: observable,
            total: observable,
            routelist: observable,
            studentAreaList: observable,
            routeDetailedData: observable,
            loadData: action,
            deleteRecord: action,
            addData: action,

            getArea: action,
            getRouteData: action
        });
        this.rootStore = rootStore;
    }

    async loadData(data) {
        this.loading = true;

        console.log(data, "data")
        const base64Input = await utf8.encode(JSON.stringify(data));
        const base2 = JSON.stringify(base64_encode(base64Input));

        var response = await postApi
            .getClient()
            .post("index.php?c=route&a=studentRouteDetails", "postData=" + base2);
        console.log("*****studentRouteDetails***", response?.data)
        this.routelist = response?.data?.data.RouteData;

        console.log(this.routelist, " this.routelist ")
        this.total = parseInt(response?.data?.TotalCount);
        this.loading = false;
        return response?.data?.data;
    }

    async addData(data) {
        var postData = { route: data };
        const base64Input = await utf8.encode(JSON.stringify(postData));
        const base2 = JSON.stringify(base64_encode(base64Input));

        var response = await postApi
            .getClient()
            .post("index.php?c=route&a=studentNewRoute", "postData=" + base2);
        return response?.data;


    }

    async getRouteData(routeId) {
        var postData = {
            routeId: routeId,
            limit: 1,
            offset: 0,
        };
        console.log("postData", postData);

        const base64Input = await base64_encode(JSON.stringify(postData));

        // const base2 = JSON.stringify(base64_encode(base64Input));
        var response = await postApi
            .getClient("")
            .post("index.php?c=route&a=studentRouteDetails", "postData=" + base64Input);
        this.routeDetailedData = response?.data?.data;
        return response?.data?.data?.RouteData[0];
    }

    async deleteRecord({ routeId }) {
        const postData = {
            routeId: routeId,
        };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=route&a=studentDeleteNewRoute", "postData=" + base64Input);



        return response;
    }
    async getArea() {
        var postData = null;
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post(
                "index.php?c=api&a=getAreaName",
                "postData=" + base64Input
            );
        console.log(response?.data?.data, "post")
        this.studentAreaList = response?.data?.data;
        return response?.data?.data;
    }
}

export default StudentRouteStore;
